export default __webpack_public_path__ + "static/introducing-cal-max-b4dc1fbef110e518b53713e8e767a84e.gif";